import { IMedia } from 'types/ICatalogue';
import { getCompressedImageUrl } from '../getCompressedImageUrl';

export const formatProductImageUrl = (productImg: IMedia[] | undefined) =>
  productImg?.map(({ url }) => `${getCompressedImageUrl(url)}?tr=w-540`);
